import { Injectable } from '@angular/core';

import type { TOfferKind } from '@core/offers-types';

import { AnalyticsBase } from '../analytics-base';

@Injectable()
export class TeamMembersAnalytics extends AnalyticsBase {
  public readonly namespace = 'Team';
  public readonly requireViewContext = true;

  public trackInviteMembers() {
    this.track('InviteNewMembers', {});
  }

  public trackMemberAccess(accessType?: TOfferKind | 'requisition') {
    this.track('ChangeMemberAccess', accessType ? { accessType } : {});
  }
}
